import { useTranslation } from 'react-i18next';
import {
  useGetEmailRule,
  useGetFullNameRule,
  useGetPhoneRule,
  useGetRequiredRule,
  useLengthValidationRule,
} from '@/hooks';
import { UserFormFieldsNames } from '../helpers/types';

export const useUserFormRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });
  const nameRule = useGetFullNameRule({ t });
  const email = useGetEmailRule({ t });
  const phoneRule = useGetPhoneRule({ t });
  const lengthRule = useLengthValidationRule({ t, min: 2, max: 200 });

  return {
    [UserFormFieldsNames.EMAIL]: [requiredRule, email],
    [UserFormFieldsNames.NAME]: [requiredRule, nameRule, lengthRule],
    [UserFormFieldsNames.PHONE_NUMBER]: [requiredRule, phoneRule],
    [UserFormFieldsNames.INVOICE_ADDRESS]: [requiredRule],
    [UserFormFieldsNames.ADDRESS]: [requiredRule],
  };
};
